export default [
  {
    path: '/approval',
    name: 'Approval',
    component: () => import('@/layout'),
    redirect: '/approval/receive',
    meta: {
      title: '会计审核',
    },
    children: [
      {
        path: 'payment-apply',
        name: 'ApprovalPaymentApplyList',
        component: () => import('@/views/web/approval/payment-apply/list'),
        meta: {
          title: '付款审核',
          noCache: false,
          auth: true,
          trackCode: 'menu-1',
          trackName: '会计审核 - 付款审核',
          activeMenu: '/approval/payment-apply',
        },
      },
      {
        path: 'refund',
        name: 'ApprovalRefundList',
        component: () => import('@/views/web/approval/refund/list'),
        meta: {
          title: '收款退款审核',
          noCache: false,
          auth: true,
          trackCode: 'menu-2',
          trackName: '会计审核 - 收款退款审核',
          activeMenu: '/approval/refund',
        },
      },
      {
        path: 'cancel-modify-order',
        name: 'CancelModifyOrderList',
        component: () => import('@/views/web/approval/cancel-modify-order/list'),
        meta: {
          title: '取消/修改订单审核',
          noCache: false,
          auth: true,
          trackCode: 'menu-3',
          trackName: '会计审核 - 取消/修改订单审核',
          activeMenu: '/approval/cancel-modify-order',
        },
      },
      {
        path: 'payment-refund',
        name: 'ApprovalPaymentRefund',
        component: () => import('@/views/web/approval/payment-refund/list'),
        meta: {
          title: '付款退款审核',
          noCache: false,
          auth: true,
          trackCode: 'menu-4',
          trackName: '会计审核 - 付款退款审核',
          activeMenu: '/approval/payment-refund',
        },
      },
      {
        path: 'sub-account',
        name: 'ApprovalSubAccountList',
        component: () => import('@/views/web/approval/sub-account/list'),
        meta: {
          title: '分账审核',
          noCache: false,
          auth: true,
          trackCode: 'menu-5',
          trackName: '会计审核 - 分账审核',
          activeMenu: '/approval/sub-account',
        },
      },
      {
        path: 'refund-list',
        name: 'ApprovalRefundLists',
        component: () => import('@/views/web/approval/refundList'),
        meta: {
          title: '退款审核',
          noCache: false,
          auth: true,
          trackCode: 'menu-6',
          trackName: '会计审核 - 退款审核',
          activeMenu: '/approval/refund-list',
        },
      },
      {
        path: 'supplement-list',
        name: 'ApprovalSupplementList',
        component: () => import('@/views/web/approval/supplement'),
        meta: {
          title: '补款审核',
          noCache: false,
          auth: true,
          trackCode: 'menu-7',
          trackName: '会计审核 - 补款审核',
          activeMenu: '/approval/supplement-list',
        },
      },
    ],
  },
];
